import React from 'react'
import { Modal } from 'reactstrap';

const PdfView = ({ preview, setPreview, baseFile }) => {
    return (
        <div>
            <Modal
                isOpen={preview}
                toggle={() => {
                    setPreview(!preview);
                }}
                id="staticBackdrop"
                scrollable={true}
                size='xl'
            >
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">Preview</h5>
                    <button type="button" className="btn-close"
                        onClick={() => {
                            setPreview(false);
                        }} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <iframe src={baseFile} className='w-100 vh-100'></iframe>
                </div>
            </Modal>
        </div>
    )
}

export default PdfView
